import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import colors from "vuetify/lib/util/colors";
import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'font-awesome/css/font-awesome.css'
import VuetifyConfirmPlugin  from "vuetify-confirm";
import VueMq from 'vue-mq'
import VueScrollactive from 'vue-scrollactive'
import Fragment from 'vue-fragment'
import VueAnalytics from 'vue-analytics'

Vue.use(VueAnalytics, {
    id: 'UA-178416411-1',
    autoTracking: {
        screenview: true
    }
})

Vue.use(Fragment.Plugin)
// use default options
Vue.use(VueScrollactive)
Vue.use(VueMq, {
    breakpoints: { // default breakpoints - customize this
        sm: 450,
        md: 1250,
        lg: Infinity,
    },
    defaultBreakpoint: 'sm' // customize this for SSR
})

const vuetify = new Vuetify({
    icons: {
        iconfont: 'md' || 'fa',
        // eslint-disable-next-line comma-dangle
    },
    theme: {
        dark: false,
        themes:{
            light:{
                primary: colors.blue.darken4    ,
                secondary: colors.grey.darken1,
                accent: colors.shades.black,
                error: colors.red.accent3,
            }
        }
    }
});

Vue.use(Vuetify);
Vue.use(VuetifyConfirmPlugin, {vuetify,
    buttonTrueText: 'Yes',
    buttonFalseText: 'No',
    color: 'warning',
    icon: 'warning',
    title: 'Warning',
    width: 350,
    persistent:false,
    property: '$confirm'
})

export default vuetify

